import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { UserPreferencesComponent } from "./user-preferences/user-preferences.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { UserPlatformWorkspacesComponent } from "./user-platform-workspaces/user-platform-workspaces.component";
import { UsersManagementComponent } from "./users-management/users-management.component";
import { ForcePasswordChangeComponent } from "./force-password-change/force-password-change.component";

export enum UserRoutes {
  ROOT = "",
  PROFILE = "profile",
  PREFERENCES = "preferences",
  PLATFORM_WORKSPACES = "platform-workspaces",
  USERS_MANAGEMENT = "users-management",
  FORCE_PASSWORD_CHANGE = "force-password-change",
}

export const routes: Routes = [
  {
    path: UserRoutes.ROOT,
    redirectTo: UserRoutes.PROFILE,
    pathMatch: "full",
  },
  {
    path: UserRoutes.PROFILE,
    component: UserProfileComponent,
  },
  {
    path: UserRoutes.PREFERENCES,
    component: UserPreferencesComponent,
  },
  {
    path: UserRoutes.PLATFORM_WORKSPACES,
    component: UserPlatformWorkspacesComponent,
  },
  {
    path: UserRoutes.USERS_MANAGEMENT,
    component: UsersManagementComponent,
  },
  {
    path: UserRoutes.FORCE_PASSWORD_CHANGE,
    component: ForcePasswordChangeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
